import React, { useEffect } from 'react';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { storageLimitsEditorBannerEntrypoint } from './entrypoint.tsx';

export const StorageLimitsEditorBanner = (props: { onClose?: () => void }): React.JSX.Element => {
	const { onClose } = props;

	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		storageLimitsEditorBannerEntrypoint,
		{},
	);

	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		entryPointActions.load();
	}, [entryPointActions]);

	return (
		<JiraEntryPointContainer
			entryPointReferenceSubject={entryPointReferenceSubject}
			id="storageLimitsEditorBanner"
			packageName="jiraStorageHardLimits"
			errorFallback="unmount"
			runtimeProps={{ onClose }}
			teamName="tako"
		/>
	);
};
